module.exports = __webpack_public_path__ + "img/cwgl.d7ca0d13.png";